export class PaymentDetails {
  person_bank_id: number;
  transaction_type: number;
  bank_id: number;
  bank_name: string;
  branch_id: number;
  branch_code: string;
  acc_type: string;
  bank_account_type_id: string;
  acc_name: string;
  acc_no: string;
  card_name: string;
  card_no: number;
  card_exp: string;
  card_cvv: number;
}
